// media query given below

<template>
    <height-watcher>
        
        <div style="background-color: gray;display: flex; align-items: center; justify-content: center;" 
            slot-scope="{ height, offset }"
            :offset="offset"
            :style="{
                'max-height': height - (40) + 'px',
                height: height - (40) + 'px',
            }">
            
          
          <!-- 0px 20px 27px rgba(0, 0, 0, 0.05); -->
                <a-card
                    :bordered="false" 
                    class="header-solid h-full c_live_official_container" 
                    :bodyStyle="{paddingTop: 0, paddingBottom: '16px' }"
                    style="">
                    <template #title>
                        <h1>{{ $t('live-communications.live-communications')}}</h1>
                        <h6 class="font-semibold m-0">{{ $t('live-communications.total-guests') }}: &nbsp;&nbsp; {{ $n(guests.length) }}</h6>
                        
                    </template>
                    <a-button class="c_end_session_btn" slot="extra" @click="endSession">{{ $t('live-communications.end-session')}}</a-button>
                    <a-list
                        class="conversations-list"
                        :split="false"
                        :data-source="guests"
                        item-layout="vertical"
                    >
                        <!-- style="height: 60%;overflow-y:scroll" -->
                        <a-list-item slot="renderItem" :item="item" slot-scope="item" >
                            <guest-list-item :item="item" />

                            <div style="margin-top: 10px;">{{ item.purpose }}</div>
                            
                            <div style="display: flex;" lot="actions"  >
                                <a-button type="primary" style="font-size: 12px !important" @click="$refs.sendLinkModal.showModal(item)">
                                    {{ $t('live-communications.call') }}
                                </a-button>
                                <a-button type="primary" style="margin-left: 15px; font-size: 12px !important; background-color: red !important; border-color: red !important" @click="reject(item)">
                                    {{ $t('live-communications.reject') }}
                                </a-button>
                            </div>
                            
                        </a-list-item>
                        <send-link-modal ref="sendLinkModal" @success="sendLink" />
                    </a-list>
                 </a-card>
                
            <!-- </a-col> -->
        </div>
    </height-watcher>
</template>

<script>
import HeightWatcher from "../../components/height-watcher/HeightWatcher.vue";
import { wsUrl } from '../../api/config';
import GuestListItem from './GuestListItem.vue';
import SendLinkModal from './SendLinkModal.vue';
import { toastMixin } from '../../mixins/ToastMixin';
import { navigationMixin } from '../../mixins/navigation-mixin';
import { liveCommunicationsClient } from '../../api/config';

export default {
    components: {
        HeightWatcher,
        GuestListItem,
        SendLinkModal
    },
    mixins: [ toastMixin, navigationMixin ],
    data() {
        return {
            ws: null,
            total: 0,
            guests: [
                
            ]
        }
    },
    methods: {
        connect() {
            this.ws = new WebSocket(wsUrl);
            this.ws.onopen = () => {
                this.connectivityStatus = 'CONNECTED'; 
                console.log('Opened'); 
                /* send authentication data */
                let authData = {
                    type: "auth",
                    params: {
                        authToken: localStorage.getItem("token")
                    }
                };
                this.ws.send(JSON.stringify(authData));

                liveCommunicationsClient.fetchAllGuestsOfPage().then(res => {
                    if (!res.networkError && res.body && res.body.length > 0) {
                        this.guests = this.guests.concat(res.body);
                        // console.log(this.guests);
                    }
                });
                
            }
            this.ws.onclose = (event) => {
                this.connectivityStatus = 'DISCONNECTED';
                if (event.code != 1000) {
                    console.log('[close] Connection died .. should reconnect');
                    this.connectivityStatus = 'RECONNECTING';
                    setTimeout(() => {
                        this.connect();
                    }, 10000);
                } else {
                    console.log(`Web Socket was closed by user code=${event.code} reason=${event.reason}`);
                }
            };
            this.ws.onerror = (error) => {
                this.connectivityStatus = 'DISCONNECTED';
                console.log(`[error] ${error.message} .. should reconnect`);
            };
            this.ws.onmessage = (event) => {
                let data = JSON.parse(event.data);
                console.log(data);
                if (data.type == 'ping') {
                    this.ws.send(JSON.stringify({ type: "pong", params: {} }));
                } else {
                    if (data.type == 'new_guest') {
                        this.total = data.params.total;
                        this.guests.push(data.params.guest);
                    } 
                    if (data.type == 'guest_leave') {
                        this.guests = this.guests.filter(g => g.mobile != data.params.guest.mobile);
                    }

                    if (data.type == 'call_failure') {
                        this.guests = this.guests.filter(g => g.mobile != data.params.mobile);
                        this.errorToast(data.params.name + this.$t('live-communications.call-failure'));
                    }
                }
            };
        },
        endSession() {
            if (this.ws)
                this.ws.send(JSON.stringify({ type: 'end_live_session' }));
            
            setTimeout(() => {
                this.navigateTo('DashboardOfficial');
            }, 1000);
            
        },
        sendLink(evt) {
            console.log(evt);
            if (this.ws) {
                this.ws.send(JSON.stringify({ type: 'call', params: evt }));
            }
        },
        reject(item) {
            if (this.ws) {
                this.ws.send(JSON.stringify({ type: 'call_rejected', params: item }));
                this.guests = this.guests.filter(g => g.mobile != item.mobile);
                console.log(item);
            }
        }
    },
    mounted() {
        console.log(wsUrl);
        this.connect();
    }

}
</script>
<style lang="scss">
    .c_live_official_container {
        width: 40%;
        height: 700; 
        margin: auto;border-radius: 12px;
        box-shadow: none !important; 
        border: solid 1px black;
    }
    @media screen and (max-width: 1787px) and (min-width: 1290px) {
        .c_live_official_container{
            .ant-card-head-title{
                h1{
                    font-size: 30px;
                }
            }
        }
    }
    @media screen and (max-width:1289px) and (min-width: 1116px){
        .c_live_official_container{
            padding-top: 20px;
            // width: 40%;

            .ant-card-head-title{
                h1{
                    font-size: 24px;
                }
            }

            .ant-card-extra{
                // margin-left: 10px !important;
                position: relative;
                left: 15px !important;
            }
        }
    }

    @media screen and (max-width:1115px) and (min-width: 758px){
        .c_live_official_container{
            padding-top: 20px;
            width: 60%;

            .ant-card-head-title{
                h1{
                    font-size: 24px;
                }
            }

            .ant-card-extra{
                // margin-left: 10px !important;
                position: relative;
                left: 15px !important;
            }
        }
    }
    @media screen and (max-width:757px) and (min-width: 522px){
        .c_live_official_container{
            padding-top: 20px;
            width: 80%;

            .ant-card-head-title{
                h1{
                    font-size: 20px;
                }
            }

            .ant-card-extra{
                // margin-left: 10px !important;
                position: relative;
                left: 15px !important;
            }
        }
    }

    @media screen and (max-width:521px) and (min-width: 417px){
        .c_live_official_container{
            padding-top: 20px;
            width: 90%;

            .ant-card-head-title{
                h1{
                    font-size: 18px;
                }
            }

            .ant-card-extra{
                // margin-left: 10px !important;
                position: relative;
                left: 15px !important;
            }
        }
    }
    @media screen and (max-width:418px) and (min-width: 392px){
        .c_live_official_container{
            padding-top: 20px;
            width: 90%;

            .ant-card-head-title{
                display: flex;
                flex-wrap: wrap;
                h1{
                    font-size: 16px;
                }
            }

            .ant-card-extra{
                // margin-left: 10px !important;
                position: relative;
                left: 15px !important;
                // top: 10px;
            }
        }
    }
    @media screen and (max-width:391px) and (min-width: 300px){
        .c_live_official_container{
            padding-top: 20px;
            width: 90%;

            .ant-card-head-title{
                display: flex;
                flex-wrap: wrap;
                h1{
                    font-size: 14px;
                }
            }

            .ant-card-extra{
                width: 24% !important;
                // margin-left: 10px !important;
                position: relative;
                // left: 1% !important;
                // top: 10px;
                .c_end_session_btn {
                    height: 50% !important;
                }
            }
        }
    }
</style>